import React, { memo, ReactElement, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Translate } from 'react-localize-redux'
import { updateLicense } from 'core/actions/Auth.actions'
import { BasePathConst } from 'configs/Path.configs'
import { ISetupLicenseFormValues, IUpdateLicenseState, TUpdateLicenseProps } from '../License.interfaces'
import styles from '../style/License.module.scss'
import SetupLicenseForm from '../license-form'
import { IAppState } from 'core/store/store'
import NoPermissionsPage from 'shared/components/no-permissions-page'
import { IAccessScope } from 'reducers/Reducers.interfaces'

function UpdateLicense (props: TUpdateLicenseProps): ReactElement {
  const [ loading, setLoading ] = useState(false)
  const [ permission, setPermission ] = useState(true)

  useEffect(() => {
    setPermission(false)
    if (props.profilePermissions && props.profilePermissions.find(permission => permission.name === 'MANAGE_OL_LICENSE') && props.accessScope === IAccessScope.system) {
      setPermission(true)
    }
  }, [props.accessScope, props.profilePermissions])

  const handleSubmit = (formValues: ISetupLicenseFormValues): void => {
    setLoading(true)
    props.updateLicense(formValues)
    .then((res: any) => {
      window.location.href = `${BasePathConst}/accounts`
    })
    .finally(() => {
      setLoading(false)
    })
  }

  return (
    <>
      {permission &&
      <div className={styles.container}>
        <header className={styles.header}>
          <h1>
            <Translate id='updateLicense.title'/>
          </h1>
        </header>

        <p>
          <Translate id='updateLicense.info'/>
        </p>

        <SetupLicenseForm onSubmit={handleSubmit} loading={loading} mode='update'/>
      </div>
      }
      {!permission &&
      <NoPermissionsPage />
      }
    </>
  )
}

UpdateLicense.displayName = 'UpdateLicense'

export default connect(
  (state: IAppState) : IUpdateLicenseState => {
    return {
      profilePermissions: state.profile.data?.permissions,
      accessScope: state.profile.data?.access_scope
    }
  },
  {
    updateLicense
  }
)(memo(UpdateLicense))
